import {env} from '@/config';
import keycloakAxios from '@/services/axios';
import {Filter} from '@/types/filter';
import {isAllowedTag} from '@/utils';

export const findAllGroups = async (
  page: number,
  filter: Filter = {},
  maxResults?: number,
  company?: string,
  userId?: string,
  tag?: string,
  findAllGroups?: boolean,
  isPublicCompany?: boolean
) => {
  const max = maxResults || 20;
  const {TAG_PAIRS} = env;
  const {location, locationLabel, ...restFilter} = filter;

  const requestBody = {
    location: locationLabel ? location : undefined,
    ...restFilter,
    company,
    userId,
    max,
    skip: max * (page - 1),
    tag: isAllowedTag(tag, TAG_PAIRS) ? tag : undefined,
    publicCompany: isPublicCompany || undefined
  };

  const response = await keycloakAxios.post('group/find', requestBody);

  if (response.status >= 300) {
    throw new Error(
      `Error finding all groups: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};

// type GetPageResult = {
//   hasNext: () => boolean;
//   getNext: () => Promise<GroupData[]>;
// };

// type QueryPostBody<T extends Record<string, any>> = {
//   pagination: {
//     page: number;
//     size: number;
//   };
//   query: T;
//   sort: Array<{
//     key: string;
//     direction: -1 | 1 | 'asc' | 'desc';
//   }>;
// };

// type GroupsQuery = {
//   location: {
//     lat: number;
//     lng: number;
//   };
//   company?: string;
// };

// export const findNearbyGroupsByPage = (
//   query: GroupsQuery,
//   size = 20
// ): GetPageResult => {
//   let page = 0;
//   let hasNext = true;

//   return {
//     getNext: async () => {
//       const token = store.getState().auth.keycloakUser?.token;
//       const { location, company } = query;
//       if (token) {
//         if (!hasNext) {
//           return [];
//         }
//         const response = company
//           ? await findAllGroups(page, token, location, company, size)
//           : await findAllGroups(page, token, location, undefined, size);
//         page += 1;
//         hasNext = response.length === size;
//         return response;
//       }
//       throw new Error('invalid token');
//     },
//     hasNext: () => hasNext
//   };
// };
